import { ZenModule } from "@/modules/zen";

export function ZenPage() {
  return (
    <div className="flex flex-col w-full">
      <ZenModule />
    </div>
  );
}
